export default "__VITE_ASSET__DW_$RNHb__"